const validatePassword = (value: string) => {
  if (value.length < 8) return 'Hasło musi mieć co najmniej osiem znaków';
  if (/^[0-9]*$/.test(value)) return 'Hasło nie może składać sie z samych cyfr';
  return true;
};

export default validatePassword;
